import {Component, HostListener, OnInit} from '@angular/core';
import {AuthenticationProvider, Browser, Key, Logger, ManagedSubscriber, WebSocketService} from '@nh/angular-tses';
import {VERSION} from '../environments/version';
import {HeaderService} from './core/header/header.service';
import {DasVersionCheckerService} from './version/das-version-checker.service';

@Component({
  selector: 'das-root',
  templateUrl: './das.component.html',
  styleUrls: ['./das.component.scss']
})
export class DasComponent extends ManagedSubscriber implements OnInit {
  public toolbarVisible;

  public browserSupported: boolean;
  public areConnected: boolean;
  public showErrorContent: boolean = false;

  public isToggleChecked: boolean = false;
  public showDefaultFocusStyle: boolean = false;

  constructor(
    private authenticationProvider: AuthenticationProvider,
    private webSocketService: WebSocketService,
    public dasVersionCheckerService: DasVersionCheckerService,
    headerService: HeaderService
  ) {
    super();
    this.subscriptions.push(
      headerService.onToolbarVisibilityChange(toolbarVisible => (this.toolbarVisible = toolbarVisible))
    );
  }

  /**
   * Initialise this component.
   */
  public ngOnInit(): void {
    this._checkBrowserSupport();
    if (!this.browserSupported) {
      return;
    }
    this.authenticationProvider
      .authenticate({keycloak: 'assets/keycloak.json'})
      .then(() => {
        this.webSocketService.connect();
      })
      .catch(err => {
        Logger.error('auth-error', 'Failed to authenticate with keycloak', err);
      });

    this._printVersion();

    this.webSocketService.onConnection(isConnected => {
      this.areConnected = isConnected;
      setTimeout(() => (this.showErrorContent = true), 4000);
    });

    if (localStorage.getItem('show-accessibility-focus') === 'true') {
      this.isToggleChecked = true;
      this.showDefaultFocusStyle = true;
    }
  }

  /**
   * Checks if the users browser is supported.
   */
  private _checkBrowserSupport(): void {
    this.browserSupported = !Browser.isInternetExplorer();
  }

  /**
   * Print DAS version information.
   */
  private _printVersion(): void {
    const words: string[] = [
      `> ${VERSION.name} `,
      VERSION.version !== 'undefined' ? `v${VERSION.version} ` : ' ',
      `(`,
      VERSION.pipeline !== 'undefined' ? `pipeline ${VERSION.pipeline}, ` : '',
      `branch '${VERSION.branch}', `,
      `revision ${VERSION.sha}, `,
      `timestamp ${VERSION.timestamp}`,
      `).`
    ];
    // eslint-disable-next-line no-console
    console.info(words.join(''));
  }

  public accessibilityToggle(value: boolean): void {
    this.isToggleChecked = value;
    if (!this.isToggleChecked) {
      this.showDefaultFocusStyle = false;
    }
  }

  @HostListener('document:keydown', ['$event'])
  public handleTab(event: KeyboardEvent): void {
    if (this.isToggleChecked) {
      const key: Key = event ? Key.fromEvent(event) : null;
      this.showDefaultFocusStyle =
        key &&
        (key.equalsUnmodified(Key.TAB) || (this.showDefaultFocusStyle && key.equalsUnmodified(new Key('Shift'))));
    }
  }

  @HostListener('document:mousedown', ['$event'])
  public handleMouseDown(event: MouseEvent): void {
    this.showDefaultFocusStyle = false;
  }
}
